import { render, staticRenderFns } from "./MessageTemplateModal.vue?vue&type=template&id=35c24096&scoped=true&"
import script from "./MessageTemplateModal.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateModal.vue?vue&type=style&index=0&id=35c24096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c24096",
  null
  
)

export default component.exports